import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import history from "./@history/index";
import LoginComponent from './components/auth/login/LoginComponent';
import { UserProvider } from './context/UserContext';
import ArticlePage from './pages/article/ArticlePage';
import ChangePassword from './pages/change-password/ChangePassword';
import HomePage from './pages/dashboard/HomePage';
import HistoryPage from "./pages/history/HistoryPage";
import LayoutPage from './pages/layout/LayoutPage';
import NotFound from "./pages/not-found/NotFound";
import ResetPassword from './pages/reset-password/ResetPassword';
import UserManagement from './pages/user-management/UserManagement';
import UserProfile from './pages/user-profile/UserProfile';
import ChatHomePage from "./pages/chat-bot/ChatHomePage"

function App() {
  return (
    <>
      <Router history={history}>
        <UserProvider>
          <ToastContainer style={{ zIndex: 50000000 }} position="top-right" autoClose={3000} className="custom-toast-container" />
          <Routes >
            <Route path="/login" element={<LoginComponent />} />
            <Route path='/reset-password/:token' element={<ResetPassword />} /> 
            <Route path='/' element={<LayoutPage />} >
            <Route index element={<HomePage />} />
            <Route path='article' element={<ArticlePage />} />
            <Route path='history' element={<HistoryPage />} />
            <Route path='/user-management' element={<UserManagement />} />
            <Route path='/user-profile' element={<UserProfile />} />
            <Route path='/change-password' element={<ChangePassword />} />
            {/* <Route path='/chatbot' element={<ChatHomePage />} />  */}
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </UserProvider>
      </Router>
    </>
  );
}

export default App;
